import useSWR from 'swr';
function checkForErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText ||
            `useApi | An api call returned HTTP status ${response.status}`);
    }
    return response;
}
const fetcher = (init) => (url) => fetch(url, init)
    .then(checkForErrors)
    .then((res) => res.json());
/**
 * @description
 * A custom hook to make a GET request using the given url using the SWR lib (https://swr.vercel.app/)
 * returns { loading, error, data }
 * @param {String} url - The url to fetch
 * @param {SWRConfiguration} options - The SWR config object - https://swr.vercel.app/docs/options
 * @param {RequestInit} init - The fetch init object - https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#supplying_request_options
 * */
export const useApi = (url, options, init) => {
    const { data, error } = useSWR(url, fetcher(init), options);
    return {
        data,
        error,
        loading: !error && !data,
    };
};
